// Generated via oats. Do NOT modify manually.

import * as t from 'io-ts';
import {excess} from '@fl/cmsch-fe-library';

// @ts-ignore: Workaround for "is declared but its value is never read."
import { CriteriaValuesBase, CriteriaValuesBaseSchema } from 'api/gen/CriteriaValuesBase';
// @ts-ignore: Workaround for "is declared but its value is never read."
import { Date, DateSchema } from 'api/gen/Date';

const requiredPart = t.interface({
  tag: t.literal('DATE'),
  leftValue: t.union([DateSchema, t.null]),
  rightValue: t.union([DateSchema, t.null]),
});

export const DateCriteriaValuesSchema = excess(t.intersection([CriteriaValuesBaseSchema.type, requiredPart]));

export interface DateCriteriaValues extends t.TypeOf<typeof DateCriteriaValuesSchema> {}
